<template>
  <button class="cw-choiceOption" @click="this.selectOption" :class="{ 'showFullScreen': this.showFullScreen, 'use-custom-padding': this.useCustomPadding }" :style="{ 'z-index': this.zindex }">
    {{ this.text }}
  </button>
</template>

<script lang="ts">

import { jsonProxy } from "@/helpers/jsonProxy";
import useAppStore from "@/store/app";

import { ChoiceOptionData, ReplyOptionsData } from "@/TickApi";
import { Component, Prop } from "vue-facing-decorator";
import { Vue } from "vue-facing-decorator";

@Component({
  emits: [],
  components: {},
})
export default class ChoiceOption extends Vue {
  @Prop() private data!: ReplyOptionsData;
  @Prop() private index!: number;
  @Prop() private useCustomPadding!: boolean;

  private get showFullScreen(): boolean {
    return useAppStore().deviceShowFullScreen;
  }

  private get zindex(): number {
    return 1000 - this.index;
  }

  private get optionsData(): ChoiceOptionData {
    return jsonProxy<ChoiceOptionData>(this.data.data || "{}", (json) => {
      //do nothing
    });
  }

  private get text() {
    return this.optionsData.text || "";
  }

  private selectOption() {
    useAppStore().replyOptionCallback(this.optionsData.value)
  }

}
</script>

<style lang="scss" scoped>
@import "@/styles/theme";

.cw-choiceOption {
  cursor: pointer;
  display: flex;
  width: auto;
  line-height: 24px;
  padding: 4px 16px;

  &.showFullScreen {
    // padding-top: clamp(10px, 2vmin, 10px) !important;
    // padding-right: clamp(10px, 4vmin, 10px) !important;
    // padding-bottom: clamp(10px, 2vmin, 10px) !important;
    // padding-left: clamp(10px, 4vmin, 10px) !important;
  }

  &.use-custom-padding {
    padding: var(--cw-conversation-message-actions-padding);
  }


  transition: background-color 120ms ease;
  align-items: center;

  background: var(--cw-conversation-message-actions-bg-color);
  color: var(--cw-conversation-message-actions-fg-color);
  border: solid var(--cw-conversation-message-actions-border-width) var(--cw-conversation-message-actions-border-color);
  border-radius: var(--cw-conversation-message-actions-border-radius);
  font-family: var(--cw-conversation-message-actions-font-family);
  font-size: var(--cw-conversation-message-actions-font-size);
  box-shadow: var(--cw-conversation-message-actions-drop-shadow);
}
</style>